
				var addMethods = require("../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["receiveMessageFromMaster"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "47b959485fc97d3986c5.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			